import React from "react";
import moment from "moment";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case "nasional":
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama BKK</th>
                <th>Jumlah BKK</th>
                <th>Jum mikroskopis dilaporkan</th>
                <th>Jum mikroskopis pns</th>
                <th>Jum mikroskopis atlm</th>
                <th>Jum mikrosopis terlatih</th>
                <th>Jum mikroskopis belum terlatih</th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg memenuhi syarat
                </th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg belum memenuhi syarat
                </th>
                <th>Jum mikroskopis yang tidak diketahui kompetensinya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_induk}</td>
                    <td>{item?.totalbkk}</td>
                    <td>{item?.jumya}</td>
                    <td>{item?.stspegawaipns}</td>
                    <td>{item?.pddkatlm}</td>
                    <td>{item?.jummikrosterlatih}</td>
                    <td>{item?.jummikrosbelumterlatih}</td>
                    <td>{item?.jumsesuaisyarat}</td>
                    <td>{item?.jumbthpeningkatan}</td>
                    <td>{item?.jummikrostdkdiketahuikompetensinya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td
                  style={{ color: "#FFF" }}
                  colSpan={currentLevel === "nasional" ? 2 : 2}
                >
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("totalbkk")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumya")}
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("stspegawaipns")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("pddkatlm")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosbelumterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumsesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumbthpeningkatan")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrostdkdiketahuikompetensinya")}
                </td>
              </tr>
            </tbody>
          </>
        );
      case "induk":
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                {currentLevel === "nasional" && (
                  <>
                    <th>BKK Induk</th>
                  </>
                )}
                <th>Nama BKK</th>
                <th>Jumlah BKK</th>
                <th>Jum BKK melapor data mikroskopis</th>
                <th>Jum mikroskopis dilaporkan</th>
                <th>Jum mikroskopis pns</th>
                <th>Jum mikroskopis atlm</th>
                <th>Jum mikrosopis terlatih</th>
                <th>Jum mikroskopis belum terlatih</th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg memenuhi syarat
                </th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg belum memenuhi syarat
                </th>
                <th>Jum mikroskopis yang tidak diketahui kompetensinya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {currentLevel === "nasional" && (
                      <>
                        <td>{item?.nm_induk}</td>
                      </>
                    )}
                    <td>{item?.nama_bkk}</td>
                    <td>{item?.totalbkk}</td>
                    <td>{item?.bkk_melapor}</td>
                    <td>{item?.jumya}</td>
                    <td>{item?.stspegawaipns}</td>
                    <td>{item?.pddkatlm}</td>
                    <td>{item?.jummikrosterlatih}</td>
                    <td>{item?.jummikrosbelumterlatih}</td>
                    <td>{item?.jumsesuaisyarat}</td>
                    <td>{item?.jumbthpeningkatan}</td>
                    <td>{item?.jummikrostdkdiketahuikompetensinya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td
                  style={{ color: "#FFF" }}
                  colSpan={currentLevel === "nasional" ? 3 : 2}
                >
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("totalbkk")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("bkk_melapor")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumbkkmikroskopis")}
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("jumya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("stspegawaipns")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("pddkatlm")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosbelumterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumsesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumbthpeningkatan")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrostdkdiketahuikompetensinya")}
                </td>
              </tr>
            </tbody>
          </>
        );
      default:
        // wilker level - detailed view
        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>BKK</th>
                <th rowSpan={2}>Tersedia mikroskopis</th>
                <th rowSpan={2}>Nama mikroskopis</th>
                <th rowSpan={2}>Kepegawaian</th>
                <th rowSpan={2}>NIP / KTP</th>
                <th rowSpan={2}>Tgl lahir</th>
                <th rowSpan={2}>Pendidikan</th>
                <th rowSpan={2}>Tgl mulai bekerja sebagai mikroskopis</th>
                <th rowSpan={2}>Jml pelatihan mikroskopis yang diikuti</th>

                {/* Pelatihan Terakhir */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Pelatihan terakhir
                </th>

                {/* Bimtek / Tes Panel Terakhir */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Bimtek / tes panel terakhir
                </th>

                {/* Uji Profisiensi */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Uji profisiensi terakhir
                </th>

                {/* Uji kompetensi */}
                <th colSpan={3} style={{ textAlign: "center" }}>
                  Uji kompetensi terakhir
                </th>

                {/* Kesimpulan */}
                <th rowSpan={2}>Memenuhi syarat sebagai mikroskopis malaria</th>
                <th rowSpan={2}>Kesimpulan</th>
              </tr>
              <tr>
                {/* Pelatihan Terakhir Sub-columns */}
                <th>Tanggal</th>
                <th>Ada nilai?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Bimtek Sub-columns */}
                <th>Tanggal</th>
                <th>Bimtek dg uji panel?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Profisiensi */}
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Kompetensi */}
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Keterangan nilai</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_bkk}</td>
                    <td>{item?.sediamikroskopis}</td>
                    <td>{item?.namapetugas || "-"}</td>
                    <td>{item?.stspegawai || "-"}</td>
                    <td>{item?.nip || "-"}</td>
                    <td>
                      {item?.tlahir
                        ? moment(item?.tlahir).format("YYYY-MM-DD")
                        : null}
                    </td>
                    <td>{item?.pddkan || "-"}</td>
                    <td>
                      {item?.tglmulaikerja
                        ? moment(item?.tglmulaikerja).format("YYYY-MM-DD")
                        : null}
                    </td>
                    <td>{item?.jumplthan || "-"}</td>

                    {/* Pelatihan Terakhir */}
                    <td>
                      {item?.thnplthanakhir
                        ? moment(item?.thnplthanakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.nilaiplth}</td>
                    <td>{item?.hslplthsensi || "-"}</td>
                    <td>{item?.hslplthspesi || "-"}</td>
                    <td>{item?.hslplthakurasi || "-"}</td>
                    <td>{item?.hslplthhtungprst || "-"}</td>
                    <td>{item?.hslpelatihan2 || "-"}</td>

                    {/* Bimtek */}
                    <td>
                      {item?.tglbimtekakhir
                        ? moment(item?.tglbimtekakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.bimtekpanel || "-"}</td>
                    <td>{item?.hslbimteksensi || "-"}</td>
                    <td>{item?.hslbimtekspesi || "-"}</td>
                    <td>{item?.hslbimtekakurasi || "-"}</td>
                    <td>{item?.hslbimtekhtungprst || "-"}</td>
                    <td>{item?.hslbimtek2 || "-"}</td>

                    {/* Uji Profisiensi */}
                    <td>
                      {item?.tglujiprofis
                        ? moment(item?.tglujiprofis).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujiprofis || "-"}</td>
                    <td>{item?.hslprofissensi}</td>
                    <td>{item?.hslprofisspesi}</td>
                    <td>{item?.hslprofisakurasi}</td>
                    <td>{item?.hslprofisparasit}</td>
                    <td>{item?.hslujiprofis2 || "-"}</td>

                    {/* Uji kompetensi */}
                    <td>
                      {item?.tglujikompakhir
                        ? moment(item?.tglujikompakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujikompakhir2 || "-"}</td>
                    <td>{item?.nilaiakhir3 || "-"}</td>

                    {/* Kesimpulan */}
                    <td>{item?.nilaiakhir4 || "-"}</td>
                    <td>{item?.kesimpulan || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={34}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === "nasional") {
    levelName = "Nasional";
  } else if (currentLevel === "induk") {
    levelName = "BKK Induk";
  } else {
    levelName = "BKK Wilker";
  }

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v4, Laporan Mikroskopis BKK</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Induk
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.induk
                ? "Semua BKK Induk"
                : reportInfo?.induk?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Wilker</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              :{" "}
              {!reportInfo?.wilker
                ? "Semua BKK Wilker"
                : reportInfo?.wilker?.split("|")[1]}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
